import { CommonListResponse } from 'common/types';
import {
  CommentScoreTag,
  CommentTypeEnum,
  ExternalEvaluateInternalParams,
  ExternalEvaluateInternalResponse,
} from 'common/types/task/comment';
import { FastApiAxiosInstance } from 'common/service/axiosInstances';

const evaluate = {
  getEvaluateTagList: (params: { score: number; projectCode: string; commentType: CommentTypeEnum }) => {
    return FastApiAxiosInstance.get<CommonListResponse<CommentScoreTag>>('/api/v1/comment/tags', { params });
  },
  saveAllocatorComment: async (payload: { parentTaskId: number; score: number; content: string; tags: any[] }) => {
    return FastApiAxiosInstance.post('/api/v1/comment/allocatorComment', payload);
  },
  getCommentList: async (payload: { parentTaskId: number; page: number; pageSize: number }) => {
    return FastApiAxiosInstance.get('/api/v1/comment/list', { params: payload });
  },
  externaEvaluateInternal: (params: ExternalEvaluateInternalParams) => {
    return FastApiAxiosInstance.post('/api/v1/comment/externalComment', params);
  },
  getComment: (params: { parentTaskId: number; commentType: CommentTypeEnum }) => {
    return FastApiAxiosInstance.get<ExternalEvaluateInternalResponse>('/api/v1/comment/getComment', { params });
  },
};

export default evaluate;
